<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import SurveyCard from '@/components/calendar/drawer/pages/cards/SurveyCard.vue';
import { addContentLogAPI } from '@/api/logServiceApi';

const props = defineProps({
  userName: { type: String, default: '' },
  isMobile: { type: Boolean, default: false },
  data: { type: Object, default: () => ({}) },
  ratingResult: { type: Number, default: 0 },
  ratingStatus: { type: Boolean, default: false },
});

const emit = defineEmits(['postRate', 'goToOverView']);

const postRate = (rate) => emit('postRate', rate);
const goToCoverPage = () => {
  addContentLogAPI('ayf_fortune_btn_restart');
  emit('goToOverView');
};
</script>

<template>
  <VRow class="full-height over-hidden">
    <!-- 왼쪽 컬럼: 콘텐츠 -->
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="ending-wrapper" :class="{ mobile: isMobile }">
          <div class="yearly-guide__footer">
            <div class="yearly-guide__footer-character"></div>
            <div class="yearly-guide__footer-content">
              <div class="yearly-guide__footer-title">낭만만세력은</div>
              <div class="yearly-guide__footer-text">
                <span>삶의 방향을 조율해가는&nbsp;</span>
                <span>따뜻한 이정표가 될 수 있도록&nbsp;</span><br />
                <span>지속적으로 연구하고,&nbsp;</span>
                <span>더 나은 서비스로 발전시켜 나가겠습니다.</span>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>

    <!-- 오른쪽 컬럼: 설문 + 다시보기 -->
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="ending-wrapper survey" :class="{ mobile: isMobile }">
          <SurveyCard
            style="width: 100%"
            :ratingResult="ratingResult"
            :ratingStatus="ratingStatus"
            @postRate="postRate"
          />
          <div class="ending-replay">
            <button class="replay-btn content_review_button_restart" @click="goToCoverPage()">
              <i class="return-icon"></i>
              다시보기
            </button>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>

<style scoped lang="scss">
.ending-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  padding-bottom: 35%;
  gap: 24px;

  &.survey {
    height: 100%;
  }

  &.mobile {
    padding: 24px 16px;
  }

  &:not(.survey) {
    height: 100%;
  }
}

.ending-replay {
  width: 100%;
  display: flex;
  justify-content: center;

  .replay-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 20px;
    border-radius: 8px;
    border: 1px solid #ebebeb;
    background: #fff;
    color: #333;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    cursor: pointer;

    .return-icon {
      display: block;
      width: 16px;
      height: 16px;
      background: url('/src/assets/images_manse/icon_return.svg') no-repeat center center;
      background-size: contain;
    }
  }
}

.yearly-guide__footer {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 32px;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  background: rgba(190, 51, 49, 0.05);
  text-align: center;

  @media (max-width: 768px) {
    padding: 20px 16px;
  }

  &-character {
    width: clamp(80px, 9vw, 140px);
    height: clamp(80px, 9vw, 140px);
    min-width: 80px;
    border-radius: 50%;
    background: url('@manseImages/yearly-fortune/img_year_guide_0104.png') center center no-repeat;
    background-size: cover;
    flex-shrink: 0;

    @media (max-width: 768px) {
      width: 100px;
      height: 100px;
    }
  }

  &-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  &-title {
    color: #be3331;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  &-text {
    max-width: 300px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;

    @media (max-width: 768px) {
      max-width: 100%;
    }
  }
}
</style>
